import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { ZeroQuantitySetting } from '~/models/administration/zeroQuantitySetting';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class ZeroQuantitySettingsService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.adminStock);
  }

  getZeroQuantitySetting() {
    return this.http.get<ZeroQuantitySetting>(this._url());
  }

  updateZeroQuantitySetting(model: any) {
    return this.client.put(this._url(), model);
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/ZeroQuantitySettings${v}`);
  }
}
